import { ChevronRight, LayoutDashboard, Users, X } from 'lucide-react';
import { resolveApiAssetUrl } from '../../../services/api';

const menuItems = [
  { label: 'E-Portal', icon: LayoutDashboard },
  { label: 'User Management', icon: Users },
];

function getBusinessInitial(name) {
  return (name || 'R').trim().charAt(0).toUpperCase();
}

function AdminSidebar({ activeView, onSelectView, selectedBusiness, isOpen, onClose }) {
  return (
    <>
      <div
        aria-hidden={!isOpen}
        className={`fixed inset-0 z-30 bg-[rgba(28,19,12,0.45)] backdrop-blur-[2px] transition lg:hidden ${
          isOpen ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0'
        }`}
        onClick={onClose}
      />

      <aside
        className={`fixed inset-y-0 left-0 z-40 flex w-[min(84vw,320px)] min-w-0 flex-col bg-[linear-gradient(180deg,#fffdfa_0%,#f2e8de_100%)] p-4 shadow-[0_24px_60px_rgba(36,24,15,0.24)] transition duration-300 lg:static lg:w-full lg:translate-x-0 lg:border-r lg:border-[#e1d4c7] lg:bg-[linear-gradient(180deg,#fffdfa_0%,#f4ebe2_100%)] lg:p-5 lg:shadow-none ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="flex h-full min-w-0 flex-col overflow-hidden rounded-[1.9rem] border border-[#dfd1c4] bg-[linear-gradient(180deg,rgba(255,255,255,0.97),rgba(247,239,231,0.98))] p-4 shadow-[0_10px_24px_rgba(69,48,33,0.06),inset_0_1px_0_rgba(255,255,255,0.72)]">
          <div className="flex items-start justify-between gap-3 border-b border-[#eee5db] pb-5">
            <div className="flex min-w-0 items-center gap-3">
              {selectedBusiness?.logo ? (
                <img
                  className="h-12 w-12 rounded-2xl border border-[#ece6df] object-cover shadow-[0_10px_22px_rgba(69,48,33,0.10)]"
                  src={resolveApiAssetUrl(selectedBusiness.logo)}
                  alt={`${selectedBusiness.name} logo`}
                />
              ) : (
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[linear-gradient(135deg,#6f5644,#8e6f58)] text-sm font-semibold text-white shadow-[0_10px_22px_rgba(69,48,33,0.18)]">
                  {getBusinessInitial(selectedBusiness?.name || 'RCM')}
                </div>
              )}

              <div className="min-w-0">
                <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-[#9a8879]">
                  Navigation
                </p>
                <h2 className="mt-1 truncate text-base font-semibold tracking-[-0.03em] text-[#201914]">
                  {selectedBusiness?.name || 'RCM Ventures'}
                </h2>
              </div>
            </div>

            <button
              aria-label="Close navigation menu"
              className="inline-flex h-10 w-10 items-center justify-center rounded-2xl border border-[#e8ddd1] bg-white text-[#6f5644] shadow-[0_10px_18px_rgba(69,48,33,0.06)] transition hover:bg-[#faf6f2] lg:hidden"
              onClick={onClose}
              type="button"
            >
              <X className="h-4 w-4" />
            </button>
          </div>

          <div className="mt-5 border-b border-[#eee5db] pb-4">
            <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-[#a39284]">
              Current Workspace
            </p>
            <p className="mt-1.5 truncate text-sm font-semibold text-[#4e3e33]">
              {selectedBusiness?.name || 'Business Portal'}
            </p>
          </div>

          <nav className="mt-5 grid min-w-0 gap-2">
            {menuItems.map(({ label, icon: Icon }) => (
              <button
                className={`flex w-full min-w-0 max-w-full items-center gap-3 overflow-hidden rounded-[1.2rem] border px-3.5 py-3.5 text-left font-inherit transition ${
                  activeView === label
                    ? 'border-[#cfbdaa] bg-[linear-gradient(135deg,#efe3d7,#faf4ee)] text-[#1b1511] shadow-[0_16px_28px_rgba(69,48,33,0.12)]'
                    : 'border-transparent bg-transparent text-[#43352b] hover:border-[#dfd1c4] hover:bg-[#fbf6f1] hover:text-[#111111]'
                }`}
                key={label}
                type="button"
                onClick={() => {
                  onSelectView(label);
                  onClose();
                }}
              >
                <span
                  className={`inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl ${
                    activeView === label ? 'bg-[#6f5644] text-white' : 'bg-[#f5efe9] text-[#6f6258]'
                  }`}
                >
                  <Icon className="h-[18px] w-[18px]" aria-hidden="true" />
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block truncate text-sm font-semibold">{label}</span>
                  <span className="mt-0.5 block truncate text-xs text-[#8f7f73]">
                    {label === 'E-Portal' ? 'Manage business workspaces' : 'Control team access'}
                  </span>
                </span>
                <ChevronRight
                  className={`h-4 w-4 shrink-0 transition ${
                    activeView === label ? 'text-[#6f5644]' : 'text-[#b4a395]'
                  }`}
                />
              </button>
            ))}
          </nav>

          <div className="mt-auto hidden rounded-[1.5rem] border border-[#eee4d8] bg-white/70 p-4 text-sm text-[#7d6d61] lg:block">
            Choose a workspace from the right panel and switch tools here anytime.
          </div>
        </div>
      </aside>
    </>
  );
}

export default AdminSidebar;
